// src/components/ui/DashedActionCard.jsx
//
// Patrón del bloque "Repositorio" del mockup: tarjeta con borde punteado,
// icono + título + descripción, que navega a otra sección al hacer click.
// Reutilizable para cualquier "atajo" similar (ej. archivados, papelera, etc).

import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { tokens } from '../../theme/tokens';

/**
 * @param {React.ReactNode} icon - icono ya dimensionado
 * @param {string} title
 * @param {string} [description] - opcional; si se omite, la tarjeta se centra (patrón "+ Añadir")
 * @param {() => void} onClick
 */
const DashedActionCard = ({ icon, title, description, onClick }) => (
  <Paper
    onClick={onClick}
    sx={{
      p: 3,
      borderRadius: `${tokens.radius.lg}px`,
      cursor: 'pointer',
      border: `2px dashed ${tokens.colors.muted2}`,
      boxShadow: 'none',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: description ? 'flex-start' : 'center',
      color: description ? undefined : tokens.colors.muted,
      '&:hover': { backgroundColor: tokens.colors.panel2, color: tokens.colors.txt, borderColor: tokens.colors.indigo },
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: description ? 2 : 1 }}>
      {icon}
      {description ? (
        <Box>
          <Typography variant="h6">{title}</Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Box>
      ) : (
        <Typography fontWeight={650} fontSize={14}>
          {title}
        </Typography>
      )}
    </Box>
  </Paper>
);

export default DashedActionCard;